export default __webpack_public_path__ + "static/collection-card-image-f63c3d95c1bf5437c5d96524aa95be01.webp";